/** VIS-timeline native item (timeline slot) model */
export default class TimelineItemModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.orderId = data.orderId ?? null;
			this.orderJobId = data.orderJobId ?? null;
			this.orderServiceJobId = data.orderServiceJobId ?? null;
			this.orderServiceJobAssigneeId = data.orderServiceJobAssigneeId ?? null;
			this.start = data.start ?? new Date();
			this.end = data.end ?? new Date();
			this.virtual = data.virtual ?? false;
			this.subcontract = data.subcontract ?? false;
		}
	}

	id = 0;
	orderId: number | null = null;
	orderJobId: number | null = null;
	orderServiceJobId: number | null = null;
	orderServiceJobAssigneeId: number | null = null;
	start = new Date();
	end = new Date();
	virtual = false;
	subcontract = false;
}